import Script from "next/script";
export function Umami({ umamiWebsiteId = "UNDEFINED" }: any) {
  return (
    <Script
      async
      src="https://umami.tunis.events/script.js"
      data-website-id={
        umamiWebsiteId != "UNDEFINED"
          ? umamiWebsiteId
          : process.env.UMAMI_MAIN_SITE_ID
      }
    ></Script>
  );
}
